<template>
  <section>
    <h2>Popover 文字提示框</h2>
    <p class="desc">展示一些提示信息</p>
    <h2>基础用法</h2>
    <div class="container">
      <div class="example">
        <span class="pop-wrapper">
          <y-popover>
            <span slot="content">弹出内容</span>
            <y-button type="info">click</y-button>
          </y-popover>
        </span>
        <span class="pop-wrapper">
          <y-popover position="bottom">
            <span slot="content">弹出内容</span>
            <y-button type="info">不同方位</y-button>
          </y-popover>
        </span>
        <span class="pop-wrapper">
          <y-popover position="right" trigger="hover">
            <span slot="content">弹出内容</span>
            <y-button type="info">hover</y-button>
          </y-popover>
        </span>
      </div>
      <div class="code-wrapper" v-highlight>
        <pre class="code"><code class="html" v-text="text1"></code></pre>
      </div>
    </div>
    <h2>Popover attributes</h2>
    <div class="attr">
      <table>
        <thead>
          <tr>
            <th>参数</th>
            <th>说明</th>
            <th>类型</th>
            <th>可选值</th>
            <th>默认值</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>position</td>
            <td>提示框出现的位置，默认在顶部</td>
            <td>String</td>
            <td>top,right,bottom,left</td>
            <td>top</td>
          </tr>
          <tr>
            <td>trigger</td>
            <td>提示框触发方式</td>
            <td>String</td>
            <td>click,hover</td>
            <td>click</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      text1: `<y-popover>
  <span slot="content">弹出内容</span>
  <y-button type="info">click</y-button>
</y-popover>
<y-popover position="bottom">
  <span slot="content">弹出内容</span>
  <y-button type="info">不同方位</y-button>
</y-popover>
<y-popover position="right" trigger="hover">
  <span slot="content">弹出内容</span>
  <y-button type="info">hover</y-button>
</y-popover>`,
    }
  },
}
</script>
